module.exports = __webpack_public_path__ + "img/phone.e296ae49.jpg";